import shuffle from "./shuffle";
function generateRandomIv(length) {
  let pool = process.env.REACT_APP_ENCRYPTION_POOL;
  pool = pool.repeat(5);
  pool = shuffle(pool);
  pool = pool.substring(0, length);
  return pool.toString();
}
export default generateRandomIv;
